<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchFun">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="员工姓名">
              <a-input placeholder="请输入" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="员工部门">
              <a-input
                placeholder="请输入"
                v-model="queryParam.department"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span
              style="float: left;overflow: hidden;"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchFun" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="resetFun"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator" style="border-top: 5px">
      <a-button @click="handleAdd" type="primary" icon="plus"
        >新增名片</a-button
      >
      <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel">
            <a-icon type="delete"/>
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down"/>
        </a-button>
      </a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;<a
          style="font-weight: 600"
          >{{ selectedRowKeys.length }}</a
        >项&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        bordered
        size="middle"
        :columns="columns"
        :dataSource="dataList"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        :rowKey="r => r.id"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="goDetails(record)">查看</a>

          <a-divider type="vertical" />
          <a @click="goEdit(record)">编辑</a>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <number-card-modal
      ref="modalForm"
      @ok="modalFormOk"
      @saveData="saveData"
    ></number-card-modal>
  </a-card>
</template>

<script>
import moment from 'moment';
import numberCardModal from './numberCardModal';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
export default {
  inject: ['reload'],
  name: 'numberCard',
  mixins: [JeecgListMixin],
  components: {
    numberCardModal
  },
  data() {
    return {
      queryParam: {},
      columns: [
        {
          title: '证书',
          align: 'center',
          dataIndex: 'cert'
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'create_time'
        },
        {
          title: '更新时间',
          align: 'center',
          dataIndex: 'update_time'
        },
        {
          title: '电话',
          align: 'center',
          dataIndex: 'phone'
        },
        {
          title: '部门',
          align: 'center',
          dataIndex: 'dept'
        },
        {
          title: '姓名',
          align: 'center',
          dataIndex: 'name',
          width: 80
        },
        {
          title: '职位',
          align: 'center',
          dataIndex: 'title'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: {
            customRender: 'action'
          },
          align: 'center'
        }
      ],
      dataList: [],
      url: {
        list:
          process.env.VUE_APP_CMS_WECHATCUSTOMER +
          '/wechatwork/customerService/data',
        delete:
          process.env.VUE_APP_CMS_WECHATCUSTOMER +
          '/wechatwork/market/userDelete',
        deleteBatch:
          process.env.VUE_APP_WECHATCUSTOMER +
          '/wechatwork/market/userDeleteBatch'
      }
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.dataList = [
        {
          img:
            'http:\/\/47.96.177.119\/qyh\/westlead\/aresoft\/upload\/image\/202010\/27\/2qkjkKaV1UQPLRVR.png',
          product: '000006,006807,006808,006806,007376,007375',
          create_time: '2020-10-27 19:10:55',
          wechat:
            'http:\/\/47.96.177.119\/qyh\/westlead\/aresoft\/upload\/image\/202010\/27\/wm3KciV8BsjNrNKb.png',
          cert: null,
          dept: '信息技术部',
          title: '测试2',
          point: '一切皆有可能',
          relation: '20bc556548444f2197b4c63621654321',
          create_by: '6d66cd54d1e8411c84d8768e514b3349',
          update_time: '2020-12-18 10:58:59',
          phone: '13661521875',
          name: '测*鹏',
          id: '46a916d3f0f848c0aee7ad8252a5c852',
          update_by: '6d66cd54d1e8411c84d8768e514b3349',
          knowledge: null
        },
        {
          img:
            'http:\/\/47.96.177.119\/qyh\/westlead\/aresoft\/upload\/image\/202009\/10\/nv6HUQgOSdcxfWg5.png',
          product: '000006,008542',
          create_time: '2020-09-10 16:14:26',
          wechat:
            'http:\/\/47.96.177.119\/qyh\/westlead\/aresoft\/upload\/image\/202009\/10\/7pGk7BQFWhkfmlYY.png',
          cert: null,
          dept: null,
          title: '销售助理1',
          point: '没事别操作！',
          relation: '2362efd4235643b1bd984dded8789006',
          create_by: '0000',
          update_time: '2020-12-18 10:54:31',
          phone: null,
          name: null,
          id: '49ee2cae878540ce87a0edfd3d65b08b',
          update_by: '6d66cd54d1e8411c84d8768e514b3349',
          knowledge: null
        },
        {
          img:
            'http:\/\/47.96.177.119\/qyh\/westlead\/aresoft\/upload\/image\/202009\/10\/WZc4TK48MZmP7VRc.png',
          product: '006807,006808,006806,009258,008544,007375',
          create_time: '2020-09-10 15:00:39',
          wechat:
            'http:\/\/47.96.177.119\/qyh\/westlead\/aresoft\/upload\/image\/202009\/10\/J8rboGmBU7NyscCl.jpg',
          cert: null,
          dept: '信息技术部',
          title: '客户经理',
          point: '投资是一门的艺术。',
          relation: 'b829ab179bb54d2d96475907e85c1cfd',
          create_by: '6d66cd54d1e8411c84d8768e514b3349',
          update_time: '2020-12-18 10:49:52',
          phone: '15190261658',
          name: '孙*传',
          id: '8063c71fbd5642abba75e6b0fbabc362',
          update_by: '6d66cd54d1e8411c84d8768e514b3349',
          knowledge: null
        },
        {
          img:
            'http:\/\/47.96.177.119\/qyh\/westlead\/aresoft\/upload\/image\/202008\/18\/ECw4Ly11ERCVCuZg.jpg',
          product: '006808,007376',
          create_time: '2020-08-18 20:03:30',
          wechat:
            'http:\/\/47.96.177.119\/qyh\/westlead\/aresoft\/upload\/image\/202008\/18\/zpoRZievzGdR1hV8.png',
          cert: '证券从业资格证',
          dept: '西部利得基金管理有限公司',
          title: '开发',
          point: '请问观点',
          relation: '82471cb106af4560919dd5ad8dabfff1',
          create_by: '0000',
          update_time: null,
          phone: null,
          name: '谭*文',
          id: 'cc5d77e0ba854bd8984e31fc1852ebe4',
          update_by: null,
          knowledge: null
        },
        {
          img:
            'http:\/\/47.96.177.119\/qyh\/westlead\/aresoft\/upload\/image\/202008\/18\/7KtYJ9XWXsp8Il88.jpg',
          product: '006806,006807,006808,007375',
          create_time: '2020-08-18 18:32:33',
          wechat:
            'http:\/\/47.96.177.119\/qyh\/westlead\/aresoft\/upload\/image\/202008\/18\/TdLFyYxLwSItanmO.png',
          cert: '基金从业资格证,证券从业资格证',
          dept: '西部利得基金管理有限公司',
          title: 'TTTTT',
          point: '666666666',
          relation: '1113',
          create_by: '6d66cd54d1e8411c84d8768e514b3349',
          update_time: null,
          phone: '13564764762',
          name: '李*李',
          id: '1ec6cc2984e44740ba168a0d01d20f16',
          update_by: null,
          knowledge: null
        },
        {
          img:
            'http:\/\/47.96.177.119\/qyh\/westlead\/aresoft\/upload\/image\/202008\/12\/llobjMqiG4DGB7Y6.jpg',
          product: '006807,006808',
          create_time: '2020-08-12 18:08:19',
          wechat:
            'http:\/\/47.96.177.119\/qyh\/westlead\/aresoft\/upload\/image\/202008\/12\/mgNyr87U4Zfer3w0.png',
          cert: '基金从业资格证,证券从业资格证',
          dept: '机构部',
          title: 'thinktank',
          point: 'ascasdcsadcfasdcf222',
          relation: '8f3292c9c49dbbafe0530100007fbb11',
          create_by: '6d66cd54d1e8411c84d8768e514b3349',
          update_time: '2020-08-12 18:09:12',
          phone: '18600081987',
          name: '成*文',
          id: '93c772f304a94b9c9761bc4af7f59da7',
          update_by: '6d66cd54d1e8411c84d8768e514b3349',
          knowledge: null
        }
      ];
    },
    searchFun() {},
    resetFun() {
      this.queryParam.name = '';
      this.queryParam.department = '';
    },
    saveData(data) {
      if (JSON.stringify(data) == '{}') {
        return;
      }

      let arr = [
        {
          key: '1',
          value: '基金从业资格证'
        },
        {
          key: '1',
          value: '证券从业资格证'
        }
      ];
      let list = [];
      data.certificate.forEach(item => {
        let obj = arr.find(e => e.key == item);
        list.push(obj.value);
      });

      let info = {
        img: data.portrait,
        product: '000006,008542',
        create_time: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        wechat: data.qrCode,
        cert: list.join(','),
        dept: null,
        title: data.duties,
        point: '没事别操作！',
        relation: '2362efd4235643b1bd984dded8789006',
        create_by: '0000',
        update_time: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        phone: null,
        name: data.name,
        id: this.getNum(),
        update_by: '6d66cd54d1e8411c84d8768e514b3349',
        knowledge: null
      };
      this.dataList.push(info);
      console.log('this.dataList', this.dataList);
      console.log('data', data);
    },
    getNum() {
      var chars = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z'
      ];
      var nums = '';
      for (var i = 0; i < 32; i++) {
        var id = parseInt(Math.random() * 61);
        nums += chars[id];
      }
      return nums;
    }
  }
};
</script>
<style scoped>
/deep/ .drawer-bootom-button {
  position: unset !important;
}
@import '~@assets/less/common.less';
</style>
